import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import TechnicalService from "@/services/TechnicalMaintenanceService.ts";
import ResponseData from "@/types/ResponseData";
import { ref, reactive, onMounted, onUpdated, watch } from "vue";
import { store } from "@/store/store";
import { useI18n } from "vue3-i18n";
import Alert from "@/components/scan/parts/Alert.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("Technical Document Specification");
const strServiceHeader = ref(store.getters.showPageTitle);
const lstCategory = reactive([]);
const strServiceSpecification = ref("");
const isBeforePageChange = ref(true);

// Variables for Detail Technical Document Information By Category
const categoryImgPath = ref("");
const isImgExist = ref(false);
const strServiceCategoryHeader = ref("");
let lstOriDocumentDetail: any[] = [];
const lstDocumentDetail = reactive([]);
const fileNameSort = ref("");
const fileNameSortIcon = ref("▲▼");
const updateDateSort = ref("");
const updateDateSortIcon = ref("▲▼");

onMounted(function () {
    getCategoryDetail();
});

watch(
    () => [store.getters.mainMenuCode, store.getters.pageClickCount],
    function () {
        if (store.getters.mainMenuCode) {
            strServiceHeader.value = store.getters.showPageTitle;
            getCategoryDetail();
            isBeforePageChange.value = true;
        }
    }
);

const getCategoryDetail = () => {
    isLoading.value = true;
    alertMessage.value = "null";
    alertState.value = "neutral";
    lstCategory.splice(0);
    strServiceSpecification.value = "";
    var data = {
        selectedTechType: 0,
        mainMenuCode: store.getters.mainMenuCode
    }
    TechnicalService.getTechnicalDocumentList(data)
        .then((response: ResponseData) => {
            if (response.data != null) {
                lstCategory.push(response.data.technicalList);
                if(response.data.specificationList.length != 0){
                    strServiceSpecification.value = response.data.specificationList[0].specification;
                }
            }
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err082") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err082") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const goToDetail = (item: any) => {
    isLoading.value = true;
    alertMessage.value = "null";
    alertState.value = "neutral";
    isBeforePageChange.value = false;
    strServiceCategoryHeader.value = item.categoryName;
    getDocumentDetailList(item.categoryId, item.fileName);
}

const getDocumentDetailList = async (categoryId: string, fileName: string) => {
    isLoading.value = true;
    alertMessage.value = "null";
    alertState.value = "neutral";
    var data = {
        selectedTechType: 1,
        categoryId: categoryId,
        fileName: fileName
    }
    await Promise.all([
        getDocumnetList(data),
        getFileByCategory(data)
    ]);
}

const getDocumnetList = (data: any) => {
    lstOriDocumentDetail = [];
    lstDocumentDetail.splice(0);
    var oriList = [];
    TechnicalService.getTechnicalDocumentList(data)
        .then((response: ResponseData) => {
            if (response.data != null) {
                oriList = response.data.technicalList;
                lstDocumentDetail.push(response.data.technicalList);
                lstOriDocumentDetail.push([...new Set(oriList.map((item: any) => item))]);
            }
            isLoading.value = false;
        })
        .catch((resError: ResponseData) => {
            if (resError.response.data.dbException != undefined) {
                const firstError = resError.response.data.dbException[0];
                alertMessage.value = i18n.t("err083") + i18n.t("err080").replace("errorMessageValue", firstError.message);
            } else {
                alertMessage.value = i18n.t("err083") + i18n.t("err080").replace("errorMessageValue", resError.response.data.error);
            }
            alertState.value = "error";
            isLoading.value = false;
        });
}

const getFileByCategory = (data: any) => {
    TechnicalService.getFileByCategory(data)
        .then((response: ResponseData) => {
            categoryImgPath.value = URL.createObjectURL(response.data);
            isImgExist.value = true;
        })
        .catch((getErr: ResponseData) => {
            categoryImgPath.value = "";
            isImgExist.value = false;
            console.log("Category image file not found.");
        });
}

const documentSort = (headerName: string) => {
    if (headerName == "documentName") {
        fileNameSortIcon.value = fileNameSort.value == "" ? "▲" : (fileNameSort.value == "Up" ? "▼" : "▲▼");
        fileNameSort.value = fileNameSort.value == "" ? "Up" : (fileNameSort.value == "Up" ? "Down" : "");
    } else if (headerName == "updateDate") {
        updateDateSortIcon.value = updateDateSort.value == "" ? "▲" : (updateDateSort.value == "Up" ? "▼" : "▲▼");
        updateDateSort.value = updateDateSort.value == "" ? "Up" : (updateDateSort.value == "Up" ? "Down" : "");
    }

    if (lstDocumentDetail.length != 0) {
        if (fileNameSort.value == "" && updateDateSort.value == "") {
            lstDocumentDetail.splice(0);
            lstDocumentDetail.push([...new Set(lstOriDocumentDetail[0].map((item: any) => item))]);
        } else {
            lstDocumentDetail[0].sort(function (x: { updateDate: string; documentName: string; }, y: { updateDate: string; documentName: string; }) {
                if (fileNameSort.value == "" && updateDateSort.value == "Up") {
                    return x.updateDate.localeCompare(y.updateDate);
                } else if (fileNameSort.value == "" && updateDateSort.value == "Down") {
                    return y.updateDate.localeCompare(x.updateDate);
                } else if (fileNameSort.value == "Up" && updateDateSort.value == "") {
                    return x.documentName.localeCompare(y.documentName);
                } else if (fileNameSort.value == "Down" && updateDateSort.value == "") {
                    return y.documentName.localeCompare(x.documentName);
                } else if (fileNameSort.value == "Up" && updateDateSort.value == "Up") {
                    return x.documentName.localeCompare(y.documentName) && x.updateDate.localeCompare(y.updateDate);
                } else if (fileNameSort.value == "Up" && updateDateSort.value == "Down") {
                    return x.documentName.localeCompare(y.documentName) && y.updateDate.localeCompare(x.updateDate);
                } else if (fileNameSort.value == "Down" && updateDateSort.value == "Up") {
                    return y.documentName.localeCompare(x.documentName) && x.updateDate.localeCompare(y.updateDate);
                } else if (fileNameSort.value == "Down" && updateDateSort.value == "Down") {
                    return y.documentName.localeCompare(x.documentName) && y.updateDate.localeCompare(x.updateDate);
                }
            });
        }
    }
}

const openDocumentFile = (item: { id: any; fileName: any; }) => {
    isLoading.value = true;
    alertMessage.value = "null";
    alertState.value = "neutral";
    var data = {
        id: item.id,
        fileName: item.fileName
    }
    TechnicalService.getFileByDocument(data)
        .then((response: ResponseData) => {
            var filePath = response.data.filePath;
            window.open(filePath)?.focus();
            isLoading.value = false;
        })
        .catch((e: Error) => {
            alert("Target file does not exist!!!");
            isLoading.value = false;
        });
}

const goBackCategoryList = () => {
    isBeforePageChange.value = true;
    strServiceCategoryHeader.value = "";
}

onUpdated(function () {
    try {
        var tableHeight = 0;
        var dataHeight = document.getElementById("tblDocumentDetailList")?.clientHeight;
        if (dataHeight != 0) {
            tableHeight = document.getElementById("divDocumentDetail")?.clientHeight;
            if (dataHeight > tableHeight) {
                document.getElementById("divHeaderDocumentDetail").style.width = "calc(100% - 16px)";
            } else {
                document.getElementById("divHeaderDocumentDetail").style.width = "100%";
            }
        }
    } catch (e) {
        isLoading.value = false;
    }
});

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, strServiceHeader, lstCategory, strServiceSpecification, isBeforePageChange, categoryImgPath, isImgExist, strServiceCategoryHeader, lstOriDocumentDetail, lstDocumentDetail, fileNameSort, fileNameSortIcon, updateDateSort, updateDateSortIcon, getCategoryDetail, goToDetail, getDocumentDetailList, getDocumnetList, getFileByCategory, documentSort, openDocumentFile, goBackCategoryList, AdminNavigation, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})